import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { getAgreement, updateAgreement } from "../actions";
import AgreementRecord from "./AgreementRecord";
import { useEsigEvent } from "../hooks/useEsigEvent";

function AgreementModal({
  agreement_id,
  setAgreement_id,
  onClosed,

  agreement,
  getAgreement,
  updateAgreement,

  ...props
}) {
  const [hasOpenedTab, setHasOpenedTab] = useState(false);

  useEsigEvent("documentSigned", async(args, event, ...rest) => {
    // console.log("esigEvent - documentSigned", args, event, rest);
    // TODO: Disabling the update action on signature for now. Weird API issue where I'm sending over _id, but get 400 back saying _id is required. But the same request works from admin side. A workaround is in place to force refresh agreements when signature modal closes.
    if (agreement?.isDefaultAgreement) {
      await updateAgreement(agreement_id, { creatorHasSigned: true });
    }
    // setAgreement_id(null);
    // console.log("esigEvent - documentSigned");
  });

  const onClosedCb = useCallback(() => {
    // TODO: this is a workaround for the issue mentioned above. Setting agreement_id to null triggers refetch in AgreementsTable
    // TODO: related issue - global agreements action required is only refreshed on a user read one, which is not triggered by the above fix.
    setAgreement_id(null);
    // console.log("onClosedCb", onClosed);
    if (typeof onClosed === "function") {
      // console.log("onClosedCb - calling optional onClosed");
      onClosed();
    }
  }, [setAgreement_id, onClosed]);

  useEffect(() => {
    if (agreement_id) {
      try {
        getAgreement(agreement_id);
      } catch (error) {
        console.error("Error fetching agreement", error);
      }
    }
  }, [agreement_id, getAgreement]);

  const handleCloseModal = () => {
    setAgreement_id(null);
  };

  // TODO: should have universal helper function for opening in a new tab
  const openSigningUrlInNewTab = useCallback(() => {
    if (agreement?.embeddedSigningUrl) {
      setHasOpenedTab(true);
      window.open(
        agreement?.embeddedSigningUrl,
        "_blank",
        "noopener,noreferrer",
      );
    }
  }, [setHasOpenedTab, agreement?.embeddedSigningUrl]);

  return (
    <Modal
      isOpen={!!agreement_id}
      toggle={handleCloseModal}
      size="md"
      onClosed={onClosedCb}
    >
      <ModalHeader toggle={handleCloseModal}>
        <span className="bold text-muted">
          View Agreement -<span className="text-body"> {agreement?.title}</span>
        </span>
      </ModalHeader>
      <ModalBody>
        <AgreementRecord agreement={agreement} />
        {agreement?.embeddedSigningUrl && (
          <div className="mt-3 text-center">
            {hasOpenedTab ? (
              <>
                <p>The signing page has been opened in a new tab.</p>
                <button
                  className="btn btn-primary"
                  onClick={openSigningUrlInNewTab}
                >
                  Open Signing Page Again
                </button>
              </>
            ) : (
              <button
                className="btn btn-primary"
                onClick={openSigningUrlInNewTab}
              >
                Open Signing Page
              </button>
            )}
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    agreement: state.agreements.agreement,
  };
};
export default connect(mapStateToProps, {
  getAgreement,
  updateAgreement,
})(AgreementModal);
